/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelManifestMovementOrder.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/manifest-movement-order";

export class AutogenModelManifestMovementOrder<RowType extends ModelRow> extends Endpoint<RowType, RowManifestMovementOrderFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowManifestMovementOrder extends ModelRow<RowManifestMovementOrderFields> {
	constructor(values?: Partial<RowManifestMovementOrderFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowManifestMovementOrderFields {
	order_id: string;
	status: string;
}

